import { getContrastingTextColor } from '@chatwoot/utils';
import {
  DEFAULT_FONT_SIZE_PX,
  DEFAULT_WIDGET_COLOR,
  MAX_FONT_SIZE,
  MIN_FONT_SIZE,
} from 'widget/helpers/appearanceHelper';

const LEGACY_FONT_SIZES = { small: 14, medium: 16, large: 18 };

export const resolvePreviewFontSize = fontSize => {
  if (fontSize === undefined || fontSize === null || fontSize === '') {
    return DEFAULT_FONT_SIZE_PX;
  }

  if (LEGACY_FONT_SIZES[fontSize]) {
    return LEGACY_FONT_SIZES[fontSize];
  }

  const parsed = parseInt(fontSize, 10);
  if (Number.isNaN(parsed)) return DEFAULT_FONT_SIZE_PX;

  return Math.min(MAX_FONT_SIZE, Math.max(MIN_FONT_SIZE, parsed));
};

export const isPreviewDarkMode = darkMode => {
  if (darkMode === 'dark') return true;
  if (darkMode === 'auto') {
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
  }
  return false;
};

const resolveHexColor = color =>
  color && /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color) ? color : null;

export const buildPreviewAppearance = ({
  darkMode = 'light',
  fontSize = DEFAULT_FONT_SIZE_PX,
  fontColor = '',
  userBubbleColor = DEFAULT_WIDGET_COLOR,
  agentBubbleColor = '',
} = {}) => {
  const isDark = isPreviewDarkMode(darkMode);
  const resolvedFontSizePx = resolvePreviewFontSize(fontSize);
  const resolvedFontSize = `${resolvedFontSizePx}px`;
  const defaultAgentText = isDark ? '#ececec' : '#0d0d0d';
  const defaultAgentBubble = isDark ? '#1a1a1a' : '#ffffff';
  const userBackground = userBubbleColor || DEFAULT_WIDGET_COLOR;
  const customFontColor = resolveHexColor(fontColor);
  const customAgentBubble = resolveHexColor(agentBubbleColor);
  const userTextColor =
    customFontColor || getContrastingTextColor(userBackground);
  const agentTextColor = customFontColor || defaultAgentText;

  return {
    isDark,
    fontSize: resolvedFontSize,
    fontSizePx: resolvedFontSizePx,
    textColor: agentTextColor,
    backgroundColor: isDark ? '#0d0d0d' : '#f9fafb',
    cardBackgroundColor: customAgentBubble || defaultAgentBubble,
    mutedTextColor: isDark ? '#adadad' : '#6b6b6b',
    inputBackgroundColor: isDark ? '#2a2a2a' : '#ffffff',
    userBubbleStyle: {
      background: userBackground,
      color: userTextColor,
      fontSize: resolvedFontSize,
    },
    agentBubbleStyle: {
      backgroundColor: customAgentBubble || defaultAgentBubble,
      color: agentTextColor,
      fontSize: resolvedFontSize,
    },
  };
};
